import React from 'react';
import Modal from 'shared/ui/modal';
import { useTranslation } from 'react-i18next';

/**
 * @param {string} [props.description] replaces the trailing
 *   "once deleted..." sentence. Omit to keep the shared default copy.
 */
const ModalDelete = ({
  title = 'delete_data',
  name = 'Data',
  isModalOpenDelete,
  setIsModalOpenDelete,
  handleDelete = () => {},
  isLoading = false,
  description = null,
}) => {
  const { t } = useTranslation('common');

  return (
    <Modal
      title={t(title)}
      isOpen={isModalOpenDelete}
      setIsOpen={setIsModalOpenDelete}
      footer={false}
      closeModal={false}
    >
      <div className="w-[400px]">
        <p className="text-gray-700 text-lg">
          {t('confirm_delete')} <span className="font-extrabold">{name}</span> ?{' '}
          {description ?? t('after_delete_warning')}
        </p>
        <div className="w-full flex justify-end text-center mt-6 gap-2">
          <button
            aria-label="Cancel Delete"
            type="button"
            onClick={() => setIsModalOpenDelete(false)}
            className="flex w-auto bg-White border justify-center rounded-md bg-con-brand px-3 py-2 text-medium font-semibold leading-6 text-slate-700 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            disabled={isLoading}
          >
            {t('cancel')}
          </button>
          <button
            aria-label="Delete Data"
            type="button"
            onClick={handleDelete}
            className="flex w-auto bg-red-500 justify-center rounded-md bg-con-brand px-3 py-2 text-medium font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            disabled={isLoading}
          >
            {isLoading ? 'Loading...' : t('delete')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export { ModalDelete };
export default ModalDelete;
